import useFundedAccount from '@/hooks/use-funded-account';
import { useSettingsStore } from '@/store/use-settings-store';
import { PnlType } from '@/types';

export default function usePnlType() {
  const { isFundedOrEval } = useFundedAccount();

  const showPositionMarketPnL = useSettingsStore(
    (state) => state.showPositionMarketPnL,
  );

  const type = (() => {
    if (isFundedOrEval) return PnlType.NET_MARKET;
    if (showPositionMarketPnL) return PnlType.MARKET;
    return PnlType.NET;
  })();

  return type;
}
